import { render, staticRenderFns } from "./Piano.vue?vue&type=template&id=f50d6d5a&scoped=true"
import script from "./Piano.vue?vue&type=script&lang=js"
export * from "./Piano.vue?vue&type=script&lang=js"
import style0 from "./Piano.vue?vue&type=style&index=0&id=f50d6d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50d6d5a",
  null
  
)

export default component.exports